import React from "react";

import "./timeline.scss";
import cn from "classnames";

interface IProps {
  timelineItems: {
    title: string;
    subtitle: string;
    description: string;
    size: number;
    color: string;
  }[];
}

export const Timeline = ({ timelineItems }: IProps) => {
  return (
    <div className="timeline-wrapper">
      {timelineItems.map((item) => {
        return (
          <div className={cn("timeline-item", `timeline-item--${item.color}`)}>
            {item.title}
            <p className="subtitle">{item.subtitle}</p>
            <p className="description">{item.description}</p>
          </div>
        );
      })}
    </div>
  );
};
